import { Component, Input, OnInit, SimpleChanges, AfterViewInit, ElementRef, ViewChild } from "@angular/core";
import { ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, Inject, PLATFORM_ID } from "@angular/core";
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import 'rxjs/add/observable/fromEvent';
import { DEVICE_INFO, APP_SETTINGS, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
@Component({
    selector: "marquee-list",
    styleUrls: ["./marquee-list.style.scss"],
    templateUrl: "./marquee-list.template.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class MarqueeList {
    @Input() item: any;
    @Input() items: any;
    @Input() swiperConfig: any;
    @Input() isOnScreen: boolean;
    @ViewChild('swiperNext') swiperNext;
    @ViewChild('swiperPrev') swiperPrev;
    @ViewChild('scrollbar') swiperScrollbar;
    @ViewChild("swipeIcon") swipeIcon;
    private scrollPos: Subscription;
    private el: ElementRef;
    public _sections: Observable<Array<any>>;
    public ready: boolean;
    private isServer: boolean;
    constructor(
        @Inject(PLATFORM_ID) platformId: string,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        @Inject(APP_SETTINGS) private appSettings: Object,
        el: ElementRef,
        private cd: ChangeDetectorRef
    ) {
        this.el = el;
        this.isServer = isPlatformServer(platformId);
    }
    private loaded: boolean;

    settings: any = {
        loop: true,
        autoplay:7500
    };

    private getObjType(item: any): string {
        return ((item.meta || item).obj_type || "").toLowerCase();
    }
    private getCTA(item: any): string {
        if (item) {
            let objType = this.getObjType(item);
            if (objType === "video" || objType === "episode" || objType === "stream") {
                return "play";
            } else {
                return objType;
            }
        }
    }
    public isMobile(): boolean {
        return this.deviceInfo.isMobile;
    }

    ngOnDestroy() {
        if (this.scrollPos) {
            this.scrollPos.unsubscribe();
        }
        this.swiperConfig = null
    }
    ngAfterViewInit() {
        let self = this;
        if (this.isMobile() && !this.isServer) {
            this.scrollPos = Observable.fromEvent(window, "scroll").subscribe(
                function (e) {

                    if (self.el.nativeElement.getBoundingClientRect().top < (window.scrollY + 50) && self.ready) {
                        self.swipeIcon.nativeElement.classList.add("fade-out");

                        self.scrollPos.unsubscribe();
                        self.cd.detectChanges();
                    }
                },
                function (err) {

                },
                function () {

                }
            )
        }
        if (!this.el.nativeElement.classList) {
            return
        }

        this.settings.loop = this.item.data.length > 1;

        this.swiperConfig = {
            //pagination: '.swiper-pagination',
            //paginationClickable: true,

            spaceBetween: 20,
            slidesPerView: 1,
            centeredSlides: false,
            loop: true,
            autoplay: 7500,
            lazyLoading: true,
            onLazyImageReady: (swiper, slide, img) => {
                let imagesLoaded = Number(slide.getAttribute("data-images-loaded"))
                let totaITems = Number(slide.getAttribute("data-total-items"))
                let loadedIndex = imagesLoaded || 0;

                // if( !imagesLoaded){
                //      slide.setAttribute("data-images-loaded", Number(0));
                // }
                //slide.dataset.imagesLoaded = Number(slide.dataset.imagesLoaded) + 1;
                slide.setAttribute("data-images-loaded", ++loadedIndex)
                if (loadedIndex === totaITems) {
                    slide.classList.add('load-complete');
                }
            },
            onInit: (inst) => {
                if (!this.loaded) {
                    this.loaded = true;
                    //this.cd.detectChanges();
                }

                if (!this.isServer) {
                    window.dispatchEvent(new Event('resize'));
                }

                this.fireScroll()
            },
            onSlideChangeStart: (inst) => {
                if (this.isMobile() && !this.isServer) {
                    // this.swipeIcon.nativeElement.classList.add('fade-out');
                }
            },
            onSlideChangeEnd: (inst) => {

                this.fireScroll()
            }
        };

        if (!this.isMobile()) {
            this.swiperConfig.nextButton = this.swiperNext.nativeElement;
            this.swiperConfig.prevButton = this.swiperPrev.nativeElement;
        } else {
            if (this.swiperScrollbar) {
                this.swiperConfig.scrollbarHide = false;
                this.swiperConfig.scrollbar = this.swiperScrollbar.nativeElement;
            }
        }
        this.ready = true;
        this.loaded = true;

        this.cd.detectChanges();
        this.el.nativeElement.classList.add("ready");
    }

    ngOnInit() {
        this.createSlidesAsync()
    }

    createSlidesAsync() {
        this._sections = Observable.create(observer => {
            if (this.deviceInfo.isPhone) {
                let items = this.item.data.slice();
                
                    items = this.sortItemsByChannel(items);
                
                items = this.sortItemsInSingles(items);
                observer.next(Array.from(items));
            }
            else {
                let items = this.item.data.slice();
                    items = this.sortItemsByChannel(items);
                
                items = this.splitArrayByChannel(items);
                observer.next(Array.from(items));
            }
            observer.complete();
        });
    }

    private sortItemsByChannel(data: Array<any>): Array<any>{
        let array = [[]];
        
        for(var i=0; i < data.length; i++)
        {
            const item1 = data[i];
            
            if(item1.meta && item1.meta.section)
            {
               if(item1.meta.section.slug == 'home')
               {
                    array[0].push(item1);
                    continue;
               }
               else
               {
                let itemFound:boolean = false;

                for(var j=0; j < array.length; j++)
                {
                    var arrayIterator = array[j];
                    if(arrayIterator.length > 0)
                    {
                        if(arrayIterator[0].meta && arrayIterator[0].meta.section)
                        {
                            if(item1.meta.section.slug == arrayIterator[0].meta.section)
                            {
                                arrayIterator.push(item1);
                                itemFound = true;
                                break;
                            }
                        }
                    }
                }
                if(itemFound)
                {
                    continue;
                }
                else
                {
                    array.push([item1]);
                    continue;
                }
               }
            }
            else{
                array.push([item1]);
            }
            
        }
        const result = array.reduce((acc, val) => acc.concat(val), []);
        return result;
    }

    

    private splitArrayByChannel(data: Array<any>): Array<any> {
        let array = [];
        let result = [];
        
        for(var i=0; i < data.length; i++)
        {
            const item1 = data[i];
            const item2 = i > 0 ? data[i - 1] : data[i];

            if(!item1.meta || !item1.meta.section || !item2.meta || !item2.meta.section)
            {
                array.push([item1]);
                result.push(array);
                array = [];
                continue;
            }

            if(item1.meta.section.slug == item2.meta.section.slug)
            {
                if(array.length == 2)
                {
                    array[1].push(item1);
                }
                else
                {
                    array.push([item1]);
                }
                
            }
            else
            {
                result.push(array);
                array = [];
                array.push([item1]);
            }
        }

        if(array.length > 0)
        {
          result.push(array);    
        }

        return Array.of(result);
    }

    private sortItemsInSingles(data: Array<any>): Array<any> {
        let result = data.map(n => Array.of([n]));
        return Array.of(result);
    }

    private fireScroll() {
        //forces lazy-load items to load when traversing the carousel
        window.dispatchEvent(new Event("scroll"));
    }

    getSeriesInfo(meta) {
        if (meta.series) {
            if (`${meta.series.title}` == `${meta.sub_head}`) {
                return `${meta.series.title}`
            }
            else {
                return `${meta.series.title} • ${meta.sub_head}`
            }
        }
        if (meta.section) {
            return meta.section.title;
        }
        return "";
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/marquee/marquee-list/marquee-list.component.ts